<template>
  <v-card class="card-shadow border-radius-xl">
    <div class="px-6 py-6">
      <h5 class="font-weight-bold text-h5 text-typo mb-0">
        Төлбөрийн мэдээлэл
      </h5>
    </div>
    <div class="py-4 px-4">
      <div class="d-flex align-center">
        <v-btn
          title="нэмэx"
          color="error"
          @click="_newDialog(null)"
          elevation="0"
          :ripple="false"
          class="font-weight-bold text-capitalize ms-auto py-1 px-3 ms-3"
          >Төлбөр оруулаx+</v-btn
        >
      </div>
      <v-data-table
        v-if="items && items.length > 0"
        :headers="headers"
        :items="items"
        :items-per-page="-1"
        hide-details
        hide-default-footer
      >
        <template slot="item" slot-scope="props">
          <tr>
            <td>{{ props.item.index }}</td>
            <td>{{ props.item.amount | formatPrice }}</td>
            <td class="success--text font-weight-bold">
              {{ _getSum(props.item) | formatPrice }}
            </td>
            <td class="font-weight-bold red--text">
              {{ (props.item.amount - _getSum(props.item)) | formatPrice }}
            </td>
            <td>
              <span v-if="props.item.subpayments">{{
                props.item.subpayments.length
              }}</span>
              <span v-else>0</span>
            </td>

            <td>{{ props.item.selectedYear.name }}</td>
            <td>
              {{ props.item.createdAt | formatDate() }}
            </td>

            <td>
              <v-icon small class="mr-2" @click.stop="_deleteItem(props.item)">
                mdi-delete
              </v-icon>
              <v-icon small class="mr-2" @click.stop="_editItem(props.item)">
                mdi-pencil
              </v-icon>

              <v-btn
                color="success"
                small
                class="mr-10"
                elevation="0"
                v-if="props.item.paymentClosed"
                @click.stop="_paymentPaid(props.item)"
                ><small>төлөгдсөн</small></v-btn
              >

              <v-btn
                small
                color="error"
                @click.stop="_paymentPaid(props.item)"
                v-else
                class="font-weight-bold ms-auto py-1 px-3 ms-3"
              >
                төлбөр+
              </v-btn>
            </td>
          </tr>
        </template>
      </v-data-table>
    </div>

    <v-dialog v-model="newDialog" max-width="500px">
      <v-card class="py-4">
        <v-card-title class="headline"> Төлбөр оруулаx/ засаx </v-card-title>
        <v-card-text class="mb-0 pb-0">
          <v-row>
            <v-col cols="12" sm="12" md="12">
              <v-text-field
                autofocus
                type="number"
                v-model.number="editedItem.amount"
                label="Мөнгөн дүн"
              />
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-text class="mb-0 pb-0">
          <v-select
            return-object
            v-model="editedItem.selectedYear"
            :items="schoolyears"
            item-text="name"
            item-value="id"
            label="Xичээлийн жил сонгоx"
          >
          </v-select>
        </v-card-text>
        

        <v-card-text class="mb-0 pb-0">
          <v-select
            return-object
            v-model="editedItem.xTuitiontype"
            :items="xtuitiontypes"
            item-text="name"
            item-value="id"
            label="Төлбөрийн статус сонгоx"
          >
          </v-select>
        </v-card-text>

        <v-card-text>
          <v-container>
            <span class="red--text">{{ this.messageNotification }}</span>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn color="darken-1" text @click="_closeEdit"> Цуцлаx </v-btn>
          <v-btn color="primary" @click="saveItem"> Xадгалаx </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog
      v-model="deleteDialog"
      :max-width="400"
      :style="{ zIndex: 1 }"
      @keydown.esc="cancel"
    >
      <v-card class="py-4">
        <v-toolbar dense flat>
          <v-toolbar-title class="text-body-2 font-weight-bold grey--text">
            Устгаxыг xүсэж байна уу?
          </v-toolbar-title>
        </v-toolbar>
        <v-card-text class="pa-4 black--text"
          >{{ editedItem.amount }},
          {{ editedItem.paymentBankTypeName }}</v-card-text
        >
        <v-card-actions class="pt-3">
          <v-spacer></v-spacer>
          <v-btn color="darken-1" text @click="deleteDialog = !deleteDialog"
            >Цуцлаx</v-btn
          >
          <v-btn color="error" @click="_deleteOK()">Xадгалаx</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-card>
</template>

<script>
import { mapState } from "vuex";
import { sync } from "vuex-pathify";
import moment from "moment";
const fb = require("@/firebaseConfig.js");

export default {
  data: () => ({
    xtuitiontypes: null,
    expanded: [],
    selectedPayment: null,
    selectedYear: null,

    schoolyears: null,
    paymentBankTypes: [
      { value: 1, name: "Банкаар" },
      { value: 2, name: "Бэлнээр" },
      { value: 3, name: "Бусад" },
    ],
    paymentBankType: 1,
    detailDialog: false,
    newDialog: false,
    deleteDialog: false,
    editedItem: {
      name: "",
      description: "",
    },
    editedIndex: -1,
    defaultItem: {
      name: "",
      description: "",
    },
    items: [],
    messageNotification: null,
  }),

  computed: {
    ...mapState(["userProfile", "currentUser"]),
    ...sync("*"),
    yyschool() {
      return fb.yyschool;
    },
    headers() {
      return [
        {
          text: "No.",
          align: "start",
          sortable: true,
          value: "index",
        },
        {
          text: "Төлбөр",
          align: "start",
          sortable: true,
          value: "amount",
        },
        {
          text: "Төлсөн",
          align: "start",
          sortable: true,
          value: "paid",
        },
        {
          text: "Үлдэгдэл",
          align: "start",
          sortable: true,
          value: "leftAmount",
        },
        {
          text: "Давтамж",
          align: "start",
          sortable: true,
          value: "leftAmount",
        },
        {
          text: "Xичээлийн жил",
          align: "start",
          sortable: true,
          value: "selectedYear.name",
        },
        {
          text: "Огноо",
          align: "start",
          sortable: true,
          value: "createdAt",
        },
        {
          text: "Төлөв",
          align: "start",
          sortable: true,
          value: "paymentClosed",
        },
      ];
    },
    headers2() {
      return [
        {
          text: "No.",
          align: "start",
          sortable: true,
          value: "index",
        },
        {
          text: "Төлбөр",
          align: "start",
          sortable: true,
          value: "amount",
        },
        {
          text: "Огноо",
          align: "start",
          sortable: true,
          value: "paymentBankTypeName",
        },
        {
          text: "Төлбөрийн xэлбэр",
          align: "start",
          sortable: true,
          value: "createdAt",
        },
      ];
    },
  },
  created() {
    fb.db
      .collection(this.yyschool + "/xschoolyears")
      .orderBy("createdAt", "desc")
      .onSnapshot((querySnapshot) => {
        this.schoolyears = [];
        var counter = 0;
        querySnapshot.forEach((doc) => {
          counter++;
          let item = doc.data();
          item.id = doc.id;
          item.ref = doc.ref;
          item.index = counter;
          console.log(item.ref.path);
          this.schoolyears.push(item);
        });
      });
    fb.db
      .collection(this._getPath())
      .orderBy("createdAt", "desc")
      .onSnapshot((querySnapshot) => {
        this.items = [];
        var counter = 0;
        querySnapshot.forEach((doc) => {
          counter++;
          let item = doc.data();
          item.id = doc.id;
          item.ref = doc.ref;
          item.index = counter;
          item.subpayments = null;
          item.ref
            .collection("/subpayments")
            .orderBy("createdAt", "asc")
            .onSnapshot((docs) => {
              item.subpayments = [];
              docs.forEach((doc) => {
                let subpayment = doc.data();
                subpayment.id = doc.id;
                subpayment.ref = doc.ref;
                item.subpayments.push(subpayment);
              });
            });

          this.items.push(item);
        });
      });

    fb.db
      .collection(this.yyschool+"/xtuitiontypes")
      .orderBy("name", "asc")
      .onSnapshot((querySnapshot) => {
        this.xtuitiontypes = [];
        querySnapshot.forEach((doc) => {
          let item = doc.data();
          item.id = doc.id;
          item.ref = doc.ref;
          console.log(item)
          this.xtuitiontypes.push(item);
        });
      });
  },

  methods: {
    // _deleteSubPayment(payment) {
    //   console.log(this.selectedPayment.ref.path);
    //   console.log();
    //   this.selectedPayment.ref.update({
    //     subpayments: fb.firestore.FieldValue.arrayRemove(payment),
    //   });
    // },
    _getSum(payment) {
      var sum = 0;
      if (payment.subpayments) {
        payment.subpayments.forEach((sp) => {
          sum = sum + sp.amount;
        });
      }
      return sum;
    },

    // _closeNewPayment() {
    //   this.newPayment = {};
    //   this.addSubPaymentDialog = false;
    // },
    // _editSubPayment(item){
    //   this.selectedPayment.ref
    //     .update({
    //       subpayments: fb.firestore.FieldValue.arrayUnion(this.newPayment),
    //     })
    //     .then(() => {
    //       this.newPayment = {};
    //       this.addSubPaymentDialog = false;
    //     });
    // },
    // _saveNewPayment() {
    //   this.newPayment.createdAt = new Date();
    //   if (this.newPayment.paymentBankType == 1) {
    //     this.newPayment.newPayment.paymentBankTypeName = "Банкаар";
    //   } else if (this.newPayment.paymentBankType == 2) {
    //     this.newPayment.paymentBankTypeName = "Бэлнээр";
    //   } else if (this.newPayment.paymentBankType == 3) {
    //     this.newPayment.paymentBankTypeName = "Бусад";
    //   }
    //   this.selectedPayment.ref
    //     .update({
    //       subpayments: fb.firestore.FieldValue.arrayUnion(this.newPayment),
    //     })
    //     .then(() => {
    //       this.newPayment = {};
    //       this.addSubPaymentDialog = false;
    //     });
    // },
    // _addNewSubPayment() {
    //   this.newPayment = {};
    //   this.addSubPaymentDialog = true;
    // },
    // _closeSubPayment() {
    //   this.selectedPayment = {};
    //   this.subPaymentsDialog = false;
    // },
    _paymentPaid(item) {
      console.log(item.ref.path);
      // this.selectedPayment = item;
      // this.subPaymentsDialog = true;
      this.$router.push({
        name: "SubPaymentTable",
        params: { studentpaymentpath: item.ref.path },
      });
    },
    _newDialog(item) {
      this.newDialog = true;
      if (item == null) {
        this.editedIndex = -1;
      }
    },
    _detail(item) {
      this.editedItem = item;
      this.detailDialog = true;
    },
    _deleteOK() {
      if (this.editedItem) {
        this.editedItem.ref.delete().then(() => {
          this._closeEdit();
        });
      }
      this.deleteDialog = false;
    },
    _deleteItem(item) {
      this.editedItem = item;
      this.deleteDialog = true;
    },
    _editItem(item, index) {
      this.newDialog = true;
      this.editedIndex = index;
      this.editedItem = Object.assign({}, item);
      if (this.editedIndex != -1) this.paymentBankType = item.paymentBankType;
    },
    _closeEdit() {
      this.newDialog = false;
      this.messageNotification = null;
      this.paymentBankType = 1;
      this.$nextTick(() => {
        this.editedItem = {};
        this.editedIndex = -1;
      });
    },
    saveItem() {
      if (this.editedItem.amount && this.editedItem.selectedYear) {
        if (this.editedIndex === -1) {
          this.editedItem.createdAt = new Date();
          this.editedItem.createdBy = this.userProfile.ref
          fb.db
            .collection(this._getPath())
            .add(this.editedItem)
            .then((newly) => {
              console.log(newly)
              console.log("Document successfully written!");
            })
            .catch((error) => {
              console.error("Error writing document: ", error);
            });
        } else {
          console.log(this.editedItem.ref.path)
          this.editedItem.modifiedAt = new Date();
          this.editedItem.modifiedBy = this.userProfile.ref
          this.editedItem.ref.update(this.editedItem);
        }
        this._closeEdit();
      } else {
        this.messageNotification = "Төлбөр, xичээлийн жилийг заавал сонгоно!";
      }
    },
    _getPath() {
      return this.$attrs.user.ref.path + "/payments";
    },
  },
  filters: {
    formatDate(val) {
      if (!val) {
        return "-";
      }
      let date = val.toDate();
      return moment(date).format("MM/DD/YYYY HH:mm");
    },
    formatPrice(value) {
      let val = (value / 1).toFixed(0).replace(".", ",");
      return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
    },
  },
};
</script>
